import { render } from "./tw-ws-funnel.vue?vue&type=template&id=55408a25"
import script from "./tw-ws-funnel.vue?vue&type=script&lang=js"
export * from "./tw-ws-funnel.vue?vue&type=script&lang=js"
script.render = render

export default script